import React from 'react';
import { graphql, withApollo, compose } from 'react-apollo';
import { Button, Modal, Col, Row, Divider, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import moment from 'moment';
import _ from 'lodash';
import Loading from '../../common/Loading';
import { errorService } from '../../../graphql/utils/utils';
import { verPdf } from '../../common/funciones/verPdf';
import { imprimirCaratulaAcuerdo } from './imprimir/imprimirCaratulaAcuerdo';

// COMPONENTS
import VisorPersona from '../../violenciaGenero/casos/VisorPersona';
import TablaDocumentosAcuerdos from './TablaDocumentosAcuerdos';
import FormPersona from '../../tramites/formularios/FormPersona';
import ModalMandarEmail from './ModalMandarEmail';
import ModalVisorEmail from '../../common/ModalVisorEmail';
import ModalUploader from './documentos/ModalUploader';
import ModalFinalizarAcuerdo from './ModalFinalizarAcuerdo';
import HeaderVerAcuerdo from './HeaderVerAcuerdo';
import Caratula from './Caratula';

// GRAPHQL
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getAcuerdoExtrajudicialPorId from '../../../graphql/querys/arreglosExtrajudiciales/getAcuerdoExtrajudicialPorId.graphql';
import confirmarDocumento from '../../../graphql/mutations/common/confirmarDocumento.graphql';
import deleteDocumento from '../../../graphql/mutations/common/deleteDocumento.graphql';
import removerDocumento from '../../../graphql/mutations/arreglosExtrajudiciales/removerDocumento.graphql';
import deleteAcuerdoExtrajudicial from '../../../graphql/mutations/arreglosExtrajudiciales/deleteAcuerdoExtrajudicial.graphql';
import enviarDocumentoPorEmail from '../../../graphql/mutations/common/enviarDocumentoPorEmail.graphql';
import updatePersonaPorId from '../../../graphql/mutations/persona/updatePersonaPorId.graphql';
import updateRequeridoPorId from '../../../graphql/mutations/arreglosExtrajudiciales/updateRequeridoPorId.graphql';
import updateCaratula from '../../../graphql/mutations/arreglosExtrajudiciales/updateCaratula.graphql';

const confirm = Modal.confirm;
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(getUsuario),
  graphql(updateCaratula, {
    name: 'updateCaratula',
  }),
  graphql(updatePersonaPorId, {
    name: 'updatePersonaPorId',
  }),
  graphql(updateRequeridoPorId, {
    name: 'updateRequeridoPorId',
  }),
  graphql(confirmarDocumento, {
    name: 'confirmarDocumento',
  }),
  graphql(deleteDocumento, {
    name: 'deleteDocumento',
  }),
  graphql(deleteAcuerdoExtrajudicial, {
    name: 'deleteAcuerdoExtrajudicial',
  }),
  graphql(removerDocumento, {
    name: 'removerDocumento',
  }),
  graphql(enviarDocumentoPorEmail, {
    name: 'enviarDocumentoPorEmail',
  })
)
class VerAcuerdoExtrajudicial extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      acuerdo: {},
      editarPersona: false,
      editandoRequerido: false,
      hayDocumentoPendiente: false,
      confirmandoDocId: null,
      visibleModalFinalizar: false,
      visibleModalMandarEmail: false,
      visibleModalVisorEmail: false,
      visibleModalUploader: false,
    };
  }

  componentDidMount() {
    this.buscarAcuerdo();
  }

  // Funcion encargada de ir a buscar al acuerdo extrajudicial
  buscarAcuerdo = () => {
    this.props.client
      .query({
        query: getAcuerdoExtrajudicialPorId,
        variables: {
          _id: this.props.match.params.id,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        let acuerdo = res.data.getAcuerdoExtrajudicialPorId;
        if (acuerdo) {
          this.setState(
            {
              loading: false,
              acuerdo,
            },
            () => {
              this.hayDocumentosPendientes();
            }
          );
        }
      })
      .catch(error => {
        console.error(error);
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  // revisa si los documentos están todos confirmados
  hayDocumentosPendientes() {
    const { documentos } = this.state.acuerdo;

    const hayPendiente = documentos.some(doc => doc.estado !== 'CONFIRMADO');

    this.setState({ hayDocumentoPendiente: hayPendiente });
  }

  // despliega modal para finalizar y cerrar el tramite
  actualizarEstado = () => {
    this.setState({
      visibleModalFinalizar: true,
    });
  };

  guardarCaratula = caratula => {
    this.setState({ loading: true });
    this.props
      .updateCaratula({
        variables: {
          idAcuerdo: this.state.acuerdo._id,
          caratula,
        },
      })
      .then(res => {
        if (res.data.updateCaratula) {
          notification.success({
            message: 'Caratula actualizada',
            description: 'Se ha editado la caratula exitosamente',
          });
        }

        this.setState(
          {
            loading: false,
          },
          () => this.buscarAcuerdo()
        );
      })
      .catch(err => {
        console.log('error al intentar editar la caratula', err);
        this.setState({
          loading: false,
        });
      });
  };

  imprimirCaratula = () => {
    imprimirCaratulaAcuerdo(this.state.acuerdo);
  };

  onEditarPersona = persona => {
    this.setState({
      editarPersona: true,
      persona,
    });
  };

  onEditarRequerido = persona => {
    this.setState({
      editarPersona: true,
      persona,
      editandoRequerido: true,
    });
  };

  onFinishEditarPersona = nuevaPersona => {
    this.setState({ loading: true });

    // si no es el requerido llamo a updatePersona
    if (!this.state.editandoRequerido) {
      this.props
        .updatePersonaPorId({
          variables: {
            _id: this.state.persona._id,
            nuevaPersona,
          },
        })
        .then(res => {
          this.setState(
            {
              editarPersona: false,
              loading: false,
            },
            () => this.buscarAcuerdo()
          );

          if (res.data.updatePersonaPorId) {
            notification.success({
              message: 'Persona editada con exito',
              description: 'Se ha editado la persona exitosamente',
            });
          }
        })
        .catch(error => {
          console.log('error al intentar editar a la persona', error);
          this.setState({
            editarPersona: false,
            loading: false,
          });
        });
    } else {
      // si es el requerido llamamos a la funcion que valida las personas duplicadas
      this.props
        .updateRequeridoPorId({
          variables: {
            idAcuerdo: this.state.acuerdo._id,
            idPersona: this.state.persona._id,
            nuevaPersona,
          },
        })
        .then(res => {
          this.setState(
            {
              editarPersona: false,
              editandoRequerido: false,
              loading: false,
            },
            () => this.buscarAcuerdo()
          );

          if (res.data.updateRequeridoPorId) {
            notification.success({
              message: 'Persona editada con exito',
              description: 'Se ha editado la persona exitosamente',
            });
          }
        })
        .catch(error => {
          console.log('error al intentar editar a la persona', error);
          this.setState({
            editarPersona: false,
            loading: false,
          });
        });
    }
  };

  confirmarDocumento = id => {
    this.setState({
      confirmandoDocId: id,
    });

    this.props
      .confirmarDocumento({
        variables: {
          _id: id,
        },
      })
      .then(res => {
        if (res.data.confirmarDocumento) {
          this.setState(
            {
              confirmandoDocId: null,
            },
            () => this.buscarAcuerdo()
          );
        }
      })
      .catch(error => {
        console.log('Error al confirmar el documento', error);
        this.setState({
          confirmandoDocId: null,
        });
        errorService(error, {
          _id: id,
        });
      });
  };

  eliminarDocumento = idDocumento => {
    let yo = this;
    confirm({
      title:
        'Realmente quiere eliminar este documento del acuerdo extrajudicial?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.setState({
          loading: true,
        });

        yo.props
          .deleteDocumento({
            variables: { _id: idDocumento },
          })
          .then(res => {
            // remuevo el documento del acuerdo
            yo.props
              .removerDocumento({
                variables: {
                  _id: yo.state.acuerdo._id,
                  idDocumento: idDocumento,
                },
              })
              .then(res => {
                if (res.data.removerDocumento) {
                  notification.warning({
                    message: 'Documento eliminado',
                    description: 'Se ha eliminado el documento exitosamente',
                  });
                }

                yo.setState(
                  {
                    loading: false,
                  },
                  () => yo.buscarAcuerdo()
                );
              })
              .catch(error => {
                Modal.error({
                  title:
                    'Error en la eliminacion del documento en el acuerdo extrajudicial',
                  content:
                    'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                });
                console.log(
                  'Existio un error a la hora de remover el documento del acuerdo',
                  error
                );
              });
          })
          .catch(error => {
            console.log(
              'Existio un error a la hora de eliminar el documento',
              error
            );
            errorService(error, {
              idDocumento,
            });

            Modal.error({
              title:
                'Error en la eliminacion del documento en el acuerdo extrajudicial',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  // funcion encargada de rellamar a la query para actualizar la tabla de documentos luego se subir un pdf
  actualizarTablaDocumentos = () => {
    this.setState(
      {
        visibleModalUploader: false,
        loading: true,
      },
      () => this.buscarAcuerdo()
    );
  };

  mostrarModalUploader = () => {
    this.setState({
      visibleModalUploader: true,
    });
  };

  ocultarModalUploader = () => {
    this.setState({
      visibleModalUploader: false,
    });
  };

  ocultarModalFinalizar = actualizarData => {
    this.setState({
      visibleModalFinalizar: false,
    });
    // si siguió los pasos y cerró el tramite actualizo el componente
    if (actualizarData) this.buscarAcuerdo();
  };

  mostrarModalMandarEmail = idDoc => {
    this.setState({
      visibleModalMandarEmail: true,
      idDocumento: idDoc,
    });
  };

  ocultarModalMandarEmail = () => {
    this.setState({
      visibleModalMandarEmail: false,
      idDocumento: null,
    });
  };

  mostrarModalVisorEmail = idDoc => {
    this.setState({
      visibleModalVisorEmail: true,
      idDocumento: idDoc,
    });
  };

  ocultarModalVisorEmail = () => {
    this.setState({
      visibleModalVisorEmail: false,
      idDocumento: null,
    });
  };

  closeEditarPersona = () => {
    this.setState({ editarPersona: false });
  };

  volver = () => {
    this.props.history.push('/tramites/acuerdosExtrajudiciales/listar');
  };

  deleteAcuerdoExtrajudicial = () => {
    const yo = this;

    confirm({
      title: '¿Estas seguro de eliminar este Acuerdo Extrajudicial?',
      icon: <Icons.ExclamationCircleFilled />,
      content: 'No podrás revertir los cambios',
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk() {
        yo.setState({ loading: true });

        yo.props
          .deleteAcuerdoExtrajudicial({
            variables: {
              _id: yo.state.acuerdo._id,
            },
          })
          .then(res => {
            yo.setState(
              {
                loading: false,
              },
              () =>
                yo.props.history.push(
                  '/tramites/acuerdosExtrajudiciales/listar'
                )
            );

            notification.success({
              message: 'El acuerdo se ha eliminado correctamente.',
            });
          })
          .catch(error => {
            console.log('ERROR al eliminar el acuerdo', error);
            yo.setState({
              loading: false,
            });

            notification.error({
              message:
                'Error a la hora de eliminar el acuerdo, intente nuevamente.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const usuario = this.props.data.getUsuario;
    const { acuerdo } = this.state;

    return (
      <div style={{ margin: 25 }}>
        <Row>
          {/* TITULO */}
          <Col span={6} offset={8}>
            <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
              <Icons.FileTextOutlined /> Acuerdo Extrajudicial N°
              {acuerdo.numero}
            </h2>
          </Col>
          {!this.state.editarPersona && (
            <Col span={9} offset={1}>
              <Button type="danger" onClick={this.volver}>
                <Icons.BackwardOutlined />
                Volver al Listado
              </Button>
            </Col>
          )}
        </Row>
        {/* SI VOY A EDITAR PERSONA OCULTO LA VISTA DEL ACUERDO */}
        {!this.state.editarPersona ? (
          <div style={estiloContent}>
            {/* CARATULA */}
            <Caratula
              acuerdo={acuerdo}
              guardarCaratula={this.guardarCaratula}
              imprimirCaratula={this.imprimirCaratula}
            />
            {/* HEADER CON LA INFO PRINCIPAL DEL ACUERDO */}
            <HeaderVerAcuerdo
              acuerdo={acuerdo}
              usuario={usuario}
              hayDocsPendientes={this.state.hayDocumentoPendiente}
              actualizarEstado={this.actualizarEstado}
            />
            <Divider />
            {/* VISORES PERSONAS */}
            <Row type={'flex'} justify={'center'}>
              <Col span={22} offset={1}>
                <VisorPersona
                  persona={acuerdo.requirente}
                  tipos={['requirente']}
                  acciones={
                    <Button
                      type="primary"
                      onClick={() => this.onEditarPersona(acuerdo.requirente)}
                    >
                      Editar
                    </Button>
                  }
                />

                {_.map(acuerdo.requeridos, requerido => {
                  return (
                    <VisorPersona
                      key={requerido._id}
                      persona={requerido}
                      tipos={['requerido']}
                      acciones={
                        <Button
                          type="primary"
                          onClick={() => this.onEditarRequerido(requerido)}
                        >
                          Editar
                        </Button>
                      }
                    />
                  );
                })}
              </Col>
            </Row>

            <Divider className="no-print" />

            <Row type={'flex'} justify={'center'}>
              <Col span={22} offset={1}>
                <TablaDocumentosAcuerdos
                  documentos={acuerdo.documentos}
                  documentoConfirmandose={this.state.confirmandoDocId}
                  mostrarModalMandarEmail={this.mostrarModalMandarEmail}
                  mostrarModalVisorEmail={this.mostrarModalVisorEmail}
                  eliminarDocumento={this.eliminarDocumento}
                  total={acuerdo.documentos.length}
                  history={this.props.history}
                  verPdf={(base64, fileName) => verPdf(base64, fileName)}
                  confirmarDocumento={this.confirmarDocumento}
                />
              </Col>
            </Row>

            <ModalFinalizarAcuerdo
              visibleModalFinalizar={this.state.visibleModalFinalizar}
              ocultarModalFinalizar={this.ocultarModalFinalizar}
              idAcuerdo={acuerdo._id}
            />

            <ModalMandarEmail
              visibleModalMandarEmail={this.state.visibleModalMandarEmail}
              ocultarModalMandarEmail={this.ocultarModalMandarEmail}
              idDocumento={this.state.idDocumento}
            />

            <ModalVisorEmail
              id={this.state.idDocumento}
              visibleModalLogsEmail={this.state.visibleModalVisorEmail}
              ocultarModalLogsEmail={this.ocultarModalVisorEmail}
            />

            <ModalUploader
              mostrarModalUploader={this.state.visibleModalUploader}
              ocultarModalUploader={this.ocultarModalUploader}
              acuerdo={acuerdo}
              actualizarTabla={this.actualizarTablaDocumentos}
              match={this.props.match}
            />

            <Divider className="no-print" />

            {/* FOOTER */}
            <Row type={'flex'} justify={'center'}>
              <Col>
                <Button
                  type="primary"
                  icon={<Icons.EditOutlined />}
                  disabled={
                    acuerdo.estado === 'FINALIZADO' || acuerdo.numero === -1
                  }
                  onClick={() =>
                    this.props.history.push(
                      `/tramites/acuerdosExtrajudiciales/${acuerdo._id}/agregarDocumento/`
                    )
                  }
                >
                  Generar Documento
                </Button>
                <Divider type="vertical" />
                <Button
                  type="primary"
                  onClick={() => this.mostrarModalUploader()}
                  disabled={
                    acuerdo.estado === 'FINALIZADO' || acuerdo.numero === -1
                  }
                >
                  <Icons.UploadOutlined /> Subir PDF
                </Button>
                <Divider type="vertical" />
                <Button
                  type="danger"
                  icon={<Icons.DeleteOutlined />}
                  onClick={this.deleteAcuerdoExtrajudicial}
                  disabled={acuerdo.estado === 'FINALIZADO'}
                >
                  Eliminar Acuerdo
                </Button>
              </Col>
            </Row>
          </div>
        ) : (
          <FormPersona
            className="formularios"
            onSubmit={this.onFinishEditarPersona}
            onAnterior={this.closeEditarPersona}
            persona={this.state.persona}
            onFinish={this.onFinishEditarPersona}
            requiereDNI={false}
          />
        )}
      </div>
    );
  }
}

export default withApollo(VerAcuerdoExtrajudicial);
